// stores/loansInPendingStatusStore.ts
import { GlobalStore } from '@roc/feature-app-core';
import { LoansInPendingStatusBaseStore } from './loansInPendingStatusBaseStore';

export class LoansInPendingStatusStore extends LoansInPendingStatusBaseStore {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(globalStore: GlobalStore) {
    super(globalStore);
  }

  reset(): void {
    this.loansInPendingStatusGridStore.reset();
  }

}